<div class="progress">
  <h1>{{text}}</h1>
  <div class="dot-pulse"></div>
</div>
